<template>
  <div class="apple-pay-button apple-pay-button-black" @click="handlePayment"></div>
</template>

<script>
import HTTP from 'axios';
import { mapState, mapMutations } from 'vuex';

// import logrocket from '@/services/logrocket';
import HTTPService from '@/services/Http';

import { API_URL } from '@/.env';

export default {
  name: 'ApplePaymentButton',
  props: {
    label: {
      type: String,
      required: true,
    },
    amount: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: true,
    },
    requestData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      paymentId: null,
      applePaySession: null,
    };
  },
  computed: {
    paymentRequest() {
      return {
        total: {
          label: this.label,
          amount: this.amount.replace(/\s/g, ''),
          type: 'final',
        },
        countryCode: 'RU',
        currencyCode: this.PROJECT.currency.code,
        merchantCapabilities: ['supports3DS', 'supportsCredit', 'supportsDebit'],
        supportedNetworks: ['masterCard', 'maestro', 'visa', 'mir'],
      };
    },
    ...mapState(['PROJECT', 'TRANSACTION_KEY']),
  },
  methods: {
    validateApplePaySession(appleUrl, callback) {
      console.log('validationURL::appleUrl', appleUrl);
      HTTP
        .post(
          `${API_URL}token/apple/validate`,
          {
            appleUrl,
          },
          {
            headers: { 'Access-Control-Allow-Origin': '*' },
          }
        )
        .then(response => {
          console.log('validationURL::response', response);
          callback(response.data);
        });
    },
    performTransaction(details, callback) {
      console.log('performTransaction::details', details);
      HTTP
        .post(
          `${API_URL}token/sale`,
          {
            paymentId: this.paymentId,
            tokenData: details.token,
            tokenType: 'applepay',
          },
          {
            headers: { 'Access-Control-Allow-Origin': '*' },
          }
        )
        .then(response => {
          console.log('performTransaction::response', response);
          callback(response.data);
        });
    },
    handleApplePayEvents() {
      console.log('handleApplePayEvents', this.applePaySession);
      if (this.applePaySession === null) {
        return;
      }

      this.applePaySession.onvalidatemerchant = event => {
        console.log('APPLE_SESSION::onvalidatemerchant', event.validationURL);

        this.validateApplePaySession(event.validationURL, merchantSession => {
          console.log('onvalidatemerchant::validateApplePaySession', merchantSession);

          this.applePaySession.completeMerchantValidation(merchantSession);
        });
      };

      this.applePaySession.onpaymentauthorized = event => {
        console.log('APPLE_SESSION::onpaymentauthorized', event, event.payment);

        this.performTransaction(event.payment, outcome => {
          console.log('onpaymentauthorized::performTransaction', outcome);

          sessionStorage.setItem('passwordCard', outcome.externalDigitalContentCode);
          this.$router.push({ name: 'payment.origin' });
        });
      };
    },
    createPayment() {
      console.log('handlePayment::createPayment', this.requestData);

      HTTPService.createPayment(this.requestData)
        .then(response => {
          const { data } = response;
          console.log('CREATE_PAYMENT::RESPONSE', data);

          this.SET_TRANSACTION(data);
          this.SET_TRANSACTION_KEY(this.label);

          this.paymentId = data.id;
          console.log('paymentId', this.paymentId);
        })
        .catch(error => {
          console.log(error);
          // logrocket.logger(error);
        });
    },
    async handlePayment() {
      if (this.disabled) {
        this.$emit('click-on-disabled');
        return;
      }

      this.$emit('loading', true);
      await this.createPayment();

      console.log('makeAppleSession::paymentRequest', this.paymentRequest);

      try {
        // eslint-disable-next-line no-undef
        this.applePaySession = new ApplePaySession(3, this.paymentRequest);
        this.SET_APPLE_PAY_SESSION(this.applePaySession);
        this.handleApplePayEvents();
        this.applePaySession.begin();
      } catch (error) {
        // logrocket.logger(error);
      }

      this.$emit('loading', false);
    },
    ...mapMutations(['SET_APPLE_PAY_SESSION', 'SET_TRANSACTION', 'SET_TRANSACTION_KEY']),
  },
};
</script>

<style lang="sass" scoped>
  @supports (-webkit-appearance: -apple-pay-button)
    .apple-pay-button
      width: 90%
      height: 80%
      -webkit-appearance: -apple-pay-button

    .apple-pay-button-black
      -apple-pay-button-style: black

    .apple-pay-button-white
      -apple-pay-button-style: white

    .apple-pay-button-white-with-line
      -apple-pay-button-style: white-outline

  @supports not (-webkit-appearance: -apple-pay-button)
    .apple-pay-button
      width: 90%
      height: 80%
      min-width: 200px
      min-height: 32px
      max-height: 64px
      padding: 0px
      display: inline-block
      background-size: 100% 60%
      background-repeat: no-repeat
      background-position: 50% 50%
      box-sizing: border-box

    .apple-pay-button-black
      background-image: -webkit-named-image(apple-pay-logo-white)
      background-color: black

    .apple-pay-button-white
      background-image: -webkit-named-image(apple-pay-logo-black)
      background-color: white

    .apple-pay-button-white-with-line
      background-image: -webkit-named-image(apple-pay-logo-black)
      background-color: white
      border: .5px solid black
</style>
